import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import Surveys from 'containers/Surveys';
import { actionTypes, reducer } from 'modules/surveys';

Object.assign(window.actionTypes, actionTypes);
window.store.injectReducer('surveys', reducer);

ReactDOM.render(
    <Provider store={window.store}>
        <Surveys />
    </Provider>,
    document.getElementById('SurveysApp')
);



// WEBPACK FOOTER //
// ./source/apps/surveys.jsx